import React from 'react';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import Anchor from '../../../../../components/link/Anchor';
import { setNumberWithComma, setDash, setColumnWidth } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { DISCOUNT_TYPE_TEXT, PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/productConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';

/**
 *  브랜드의 상품 리스트
 */
const columns = (data) => {
  const { list, getProductSubCategoryList } = data;

  return [
    {
      accessor: 'id',
      Header: '상품번호',
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
    },
    {
      accessor: 'url',
      Header: '이미지',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'name',
      Header: '상품명',
      resizable: true,
      width: 300,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.id} />,
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      width: setColumnWidth(list, 'mainCategory') + 40,
    },
    {
      accessor: 'isSubCategoryExists',
      Header: '2차 카테고리',
      width: 120,
      Cell: (row) =>
        row.value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getProductSubCategoryList({
                productId: row.original.id,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'status',
      Header: '상품상태',
      Cell: (row) => PRODUCT_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'originPrice',
      Header: '판매가(원)',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountType',
      Header: '할인설정',
      Cell: (row) => setDash(DISCOUNT_TYPE_TEXT[row.value]),
    },
    {
      accessor: 'discountPrice',
      Header: '할인가(원)',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountRate',
      Header: '할인율',
      Cell: (row) => setNumberWithComma(row.value, '%'),
    },
    {
      accessor: 'discountedPrice',
      Header: '할인된 판매가(원)',
      width: 120,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'salesPrice',
      Header: '실판매가',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'detailCount',
      Header: '상세 유입 수',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'likeCount',
      Header: '찜 수',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'cartCount',
      Header: '카트에 넣은 횟수',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'salesCount',
      Header: '판매 수',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'cancelCount',
      Header: '취소/반품/교환',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'rate',
      Header: '평점',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'createDate',
      Header: '등록일자',
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
